<template>
  <div class="settings">
    <Confirm ref="confirm" />

    <v-card
      outlined
      max-width="900"
    >
      <template>
        <v-card-title>
          <span>アカウント削除</span>
        </v-card-title>
        <v-card-text>
          <p>
            アカウントを削除すると投稿やお気に入りを含む全てのデータが即時削除されます。<br>
            これらのデータは二度と元に戻せません。十分ご注意ください。
          </p>
          <v-btn
            depressed
            color="error"
            :loading="isLodingDelete"
            @click="deleteUser"
          >
            削除
          </v-btn>
        </v-card-text>
      </template>
    </v-card>
  </div>
</template>

<style lang="scss">
.settings {
  > * {
    margin: auto;
  }
}
</style>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';

export default {
  data: () => ({
    isLodingDelete: false
  }),
  methods: {
    async deleteUser() {
      if (!await this.$refs.confirm.open('本当にアカウントを削除しますか？', '削除', 'error')) {
        return;
      }
      this.isLodingDelete = true;
      await firebase.auth().currentUser.delete()
        .then(() => {
          this.$_pushNotice('アカウントを削除しました。\nホームに戻ります。', 'success');
          this.$router.push({ name: 'home' });
        })
        .catch(err => {
          console.log(err);
          if (err.code === 'auth/requires-recent-login') {
            this.$_pushNotice('エラーが発生しました。\nログインし直して再試行してください。', 'error');
          } else {
            this.$_pushNotice('エラーが発生しました。', 'error');
          }
        })
        .finally(() => {
          this.isLodingDelete = false;
        });
    }
  }
};
</script>
